import { memo, useCallback, useState } from 'react';
import Image from 'next/image';
import { Box, Typography } from '@mui/material';

import { usePersistentplanAndFreq } from 'store/planAndFreq';
import { updateCart } from 'store/cartItems';

import CuminButton from '@components/Button';
import { getCategorizedProductsType, productType } from '@utils/types';
import { BESTSELLER_BUNDLE } from '@utils/data';
import { productFlatListVar } from 'store/productsFlatList';
import { useReactiveVar } from '@apollo/client';

import BundleModal from '../BundleModal';
import { useStyles } from './useStyles';

interface IBundles {
  bundleId: number;
  categories: getCategorizedProductsType[];
  mode?: string;
  elevarAddToCartEvent?: any;
}

const Bundles = ({
  categories,
  bundleId,
  mode,
  elevarAddToCartEvent,
}: IBundles) => {
  const [openBundleModal, setOpenBundleModal] = useState<boolean>(false);
  const [modalContent, setModalContent] =
    useState<getCategorizedProductsType>();

  const classes = useStyles();

  const planAndFreq = usePersistentplanAndFreq();
  const { productFlatList } = useReactiveVar(productFlatListVar);

  const handleAddToCart = (products: productType[], category_name: string) => {
    const productIdQuantityList: any = {};
    products?.slice(0, 5)?.forEach((product) => {
      if (planAndFreq.selectedPlan === 5) {
        productIdQuantityList[product.id] = 1;
      } else if (planAndFreq.selectedPlan === 10) {
        productIdQuantityList[product.id] = 2;
      } else if (planAndFreq.selectedPlan === 20) {
        productIdQuantityList[product.id] = 4;
      }
    });

    if (!mode && elevarAddToCartEvent) {
      Object.entries(productIdQuantityList).map(
        ([productId, quantity]: any) => {
          const product = productFlatList[productId];

          for (let i = 1; i <= +quantity; i++) {
            //fire elevar add to cart event
            elevarAddToCartEvent(product);
          }
        }
      );
    }

    updateCart(productIdQuantityList);
    //@ts-ignore
    window?.dataLayer.push({
      text: category_name,
      event: 'bundle_add_to_cart',
    });
  };

  const handleOnImgClick = (category: getCategorizedProductsType) => {
    setModalContent(category);
    setOpenBundleModal(true);
    //@ts-ignore
    window?.dataLayer.push({
      text: category?.category_name,
      event: 'bundle_open',
    });
  };

  const handleClose = useCallback(() => {
    setOpenBundleModal(false);
  }, [setOpenBundleModal]);

  return (
    <>
      <BundleModal
        open={openBundleModal}
        handleClose={handleClose}
        category={modalContent}
        handleAddToCart={handleAddToCart}
      />
      <Box className={classes.mainContainer} id={bundleId.toString()}>
        <Typography
          variant="h2"
          align="left"
          color="cinnamon.main"
          m="30px 0 10px"
        >
          Bundles
        </Typography>
        <Typography variant="body2" align="left" color="cumin.main" mb="30px">
          Not sure what to choose? We've curated some great bundles for you.
        </Typography>
        <Box className={classes.categoryContainer}>
          {categories
            ?.filter(({ uiType }) => uiType === 'BUNDLE')
            ?.map((category) => (
              <Box key={category?.category_id} className={classes.category}>
                <Box
                  className={classes.imgWrapper}
                  onClick={() => handleOnImgClick(category)}
                >
                  <Image
                    src={category.categoryImage}
                    objectFit="cover"
                    layout="fill"
                  />
                </Box>
                <CuminButton
                  color="cinnamon"
                  variant="contained"
                  textColor="whitePepper.main"
                  width="200px"
                  height="48"
                  borderRadius="24"
                  onClick={() =>
                    handleAddToCart(category?.products, category.category_name)
                  }
                >
                  Add to Cart
                </CuminButton>
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
};

export default memo(Bundles);
